import { useLocation, useNavigate } from "react-router-dom";
import { Home, TreeDeciduous, Plus, LayoutGrid, User as UserIcon } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const HIDDEN_PATHS = ["/privacy-onboarding"];

export const MobileBottomNav = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useLang();
    if (HIDDEN_PATHS.includes(location.pathname)) return null;
    const isActive = (paths) => paths.some((p) => location.pathname === p || location.pathname.startsWith(`${p}/`));
    const tabs = [
        { key: "home",    label: t("mbHome"), icon: Home,          paths: ["/dashboard"] },
        { key: "tree",    label: t("mbTree"), icon: TreeDeciduous, paths: ["/family-tree"] },
        { key: "add",     label: t("mbAdd"),  icon: Plus,          paths: ["/add-member"], primary: true },
        { key: "hub",     label: t("mbHub"),  icon: LayoutGrid,    paths: ["/family"] },
        { key: "profile", label: t("mbMe"),   icon: UserIcon,      paths: ["/profile"] },
    ];
    return (
        <>
            {/* In-flow spacer so page content never hides behind the fixed bar */}
            <div className="h-20 md:hidden" aria-hidden="true" />
            <nav
                data-testid="app-shell-bottom-tabs"
                className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur border-t border-[#E5EAE3] shadow-[0_-4px_18px_rgba(15,51,17,0.06)]"
                style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
            >
                <div className="grid grid-cols-5 h-16">
                    {tabs.map((t) => {
                        const active = isActive(t.paths);
                        const Icon = t.icon;
                        if (t.primary) {
                            return (
                                <button
                                    key={t.key}
                                    type="button"
                                    onClick={() => navigate(t.paths[0])}
                                    data-testid={`app-shell-bottom-tab-${t.key}`}
                                    className="flex items-center justify-center"
                                >
                                    <span className="-mt-6 h-14 w-14 rounded-full bg-gradient-to-br from-[#2E7D32] to-[#1B5E20] text-white flex items-center justify-center shadow-[0_10px_24px_rgba(27,94,32,0.35)] ring-4 ring-white">
                                        <Icon className="h-6 w-6" strokeWidth={2.2} />
                                    </span>
                                </button>
                            );
                        }
                        return (
                            <button
                                key={t.key}
                                type="button"
                                onClick={() => navigate(t.paths[0])}
                                data-testid={`app-shell-bottom-tab-${t.key}`}
                                className={`flex flex-col items-center justify-center gap-0.5 text-[10.5px] font-semibold transition-colors ${
                                    active ? "text-[#1B5E20]" : "text-[#4A5D4E]"
                                }`}
                            >
                                <Icon className={`h-5 w-5 ${active ? "text-[#1B5E20]" : ""}`} strokeWidth={active ? 2.4 : 2} />
                                <span>{t.label}</span>
                                {active && <span className="h-0.5 w-5 rounded-full bg-[#1B5E20]" />}
                            </button>
                        );
                    })}
                </div>
            </nav>
        </>
    );
};
